'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// MODULE NAME & REDUCER KEY
var NAME = exports.NAME = 'sdiQuickQuote';

// ACTION TYPES
var actionTypes = exports.actionTypes = {
  QUOTE: NAME + '/QUOTE',
  CLEAR_QUOTES: NAME + '/CLEAR_QUOTES'
};
var url = exports.url = process.env.REACT_APP_API_BASE_URI + '/sdi/v1/public/quick-quote';